import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

/**
 * Compact PGA membership pill used on `/coaches/search` marketplace cards.
 * When an explainer id is present the pill is a button that opens
 * `CoachAccreditationExplainerDialog`. The flagged coach-profile booking
 * card does not render this tag.
 */
const useStyles = makeStyles((theme) => ({
  membershipTag: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    height: 22,
    margin: 0,
    padding: '0 10px',
    borderRadius: 999,
    backgroundColor: 'rgba(0, 35, 75, 0.08)',
    color: theme.palette.secondary.main,
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.02em',
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
  membershipTagButton: {
    position: 'relative',
    zIndex: 3,
    pointerEvents: 'auto',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    appearance: 'none',
    transition: 'background-color 140ms ease',
    '&:hover, &:focus-visible': {
      backgroundColor: 'rgba(0, 35, 75, 0.14)',
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
  },
}))

function MembershipTag({
  label,
  explainerId,
  onOpenExplainer,
}) {
  const styles = useStyles()

  if (!label) return null

  if (explainerId) {
    return (
      <button
        type="button"
        className={`${styles.membershipTag} ${styles.membershipTagButton}`}
        data-testid="coach-card-membership-tag"
        aria-label={`Learn more about ${label}`}
        aria-haspopup="dialog"
        onClick={(event) => {
          event.stopPropagation()
          event.preventDefault()
          onOpenExplainer(explainerId)
        }}
      >
        {label}
      </button>
    )
  }

  return (
    <span className={styles.membershipTag} data-testid="coach-card-membership-tag">
      {label}
    </span>
  )
}

MembershipTag.propTypes = {
  label: PropTypes.string,
  explainerId: PropTypes.string,
  onOpenExplainer: PropTypes.func.isRequired,
}

MembershipTag.defaultProps = {
  label: undefined,
  explainerId: null,
}

export default MembershipTag
